export default __webpack_public_path__ + "static/media/st.da890660.jpg";